import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './EhxcelApp'; 
import { AuthProvider } from './context/AuthContext'; 
import './index.css';
import './i18n'; // Initialize i18n

// Ensure the root element exists to satisfy strict null checks
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);